import { LRUCache } from "lru-cache";

class RepositoryCache {
  constructor(maxSize, ttl) {
    this.cache = new LRUCache({
      max: maxSize,
      ttl: ttl,
      updateAgeOnGet: true, // Update access time when getting items.
      allowStale: false, // Don't return expired items.
    });
  }

  createKey(namespace, key) {
    return `${namespace}:${key}`;
  }

  get(key) {
    return this.cache.get(key) || null;
  }

  set(key, data, ttl = this.cache.ttl) {
    this.cache.set(key, data, { ttl });
  }

  clear() {
    this.cache.clear();
  }
}

export default RepositoryCache;
